import { render, staticRenderFns } from "./ETransAddressTextarea.vue?vue&type=template&id=51a37f64&scoped=true"
import script from "./ETransAddressTextarea.vue?vue&type=script&lang=js"
export * from "./ETransAddressTextarea.vue?vue&type=script&lang=js"
import style0 from "./ETransAddressTextarea.vue?vue&type=style&index=0&id=51a37f64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a37f64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a37f64')) {
      api.createRecord('51a37f64', component.options)
    } else {
      api.reload('51a37f64', component.options)
    }
    module.hot.accept("./ETransAddressTextarea.vue?vue&type=template&id=51a37f64&scoped=true", function () {
      api.rerender('51a37f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/ETransAddressTextarea.vue"
export default component.exports